import axios from "../../config/interceptor";
import { PER_PAGE_SIZE } from "../../utils/constants";

export const getPackageOptions = async (businesId) => {
  try {
    let link =
      `/lambda/v1/get-package-options/${businesId}`;

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const postPackage = async (data) => {
  try {
    const response = await axios.post(
      `/lambda/v1/packages`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const putPackage = async (data) => {
  try {
    const response = await axios.put(
      `/lambda/v1/packages/${data.id}`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getPackages = async ({
  page = 0,
  size = PER_PAGE_SIZE,
  businessId,
  sortKey,
  sortValue,
  active,
}) => {
  try {
    let link = `/lambda/v1/packages/${businessId}?`;
    link = link.concat("page=" + page);
    link = link.concat("&size=" + size);
    if (sortKey) link = link.concat("&sortKey=" + sortKey);
    if (sortValue) link = link.concat("&sortValue=" + sortValue);
    if (active === true) link = link.concat("&active=true");
    else if (active === false) link = link.concat("&active=false");

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const getPackageDetail = async (id) => {
  try {
    const response = await axios.get(
      `/lambda/v1/packages/detail/${id}`
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const deletePackage = async (id) => {
  try {
    const response = await axios.delete(
      `/lambda/v1/packages/${id}`
    );

    return response;
  } catch (error) {
    return error;
  }
};
